<template>
  <li v-if="canViewVerticalNavMenuLink(item)" class="nav-item" :class="{
    'active': isActive,
    'disabled': item.disabled
  }">
    <b-link v-bind="linkProps" class="d-flex align-items-center">
      <feather-icon :icon="item.icon || 'CircleIcon'" />
      <span class="menu-title text-truncate">{{ t(item.title) }}</span>
      <b-badge v-if="num!='' && num != 0 " pill :variant="item.tagVariant || 'primary'" class="mr-1 ml-auto">
        {{ num }}
      </b-badge>
    </b-link>
  </li>
</template>

<script>
import { useUtils as useAclUtils } from '@core/libs/acl'
import { BLink, BBadge } from 'bootstrap-vue'
import { useUtils as useI18nUtils } from '@core/libs/i18n'
import useVerticalNavMenuLink from './useVerticalNavMenuLink'
import mixinVerticalNavMenuLink from './mixinVerticalNavMenuLink'

export default {
  components: {
    BLink,
    BBadge,
  },
  mixins: [mixinVerticalNavMenuLink],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      timer1: '',
      num: '',
    };
  },
  mounted() {
    //每隔三秒，去查询一次状态
    this.timer1 = setInterval(() => {
      this.getNum();
    }, 1000);
  },

  unmounted() {
    // 清理定时器
    if (this.timer1) {
      clearInterval(this.timer1);
    }
  },

  methods: {

    getNum() {
      const dxqnum = localStorage.getItem('footy_dxqnum');
      const rqnum = localStorage.getItem('footy_rqnum');
      const jqnum = localStorage.getItem('footy_jqnum');

      const cp_dxqnum = localStorage.getItem('footy_cp_dxqnum');
      const cp_rqnum = localStorage.getItem('footy_cp_rqnum');
      const cp_jqnum = localStorage.getItem('footy_cp_jqnum');
      if (this.item.route == 'zdDxq') {
        this.num = dxqnum;
      }
      if (this.item.route == 'zdRq') {
        this.num = rqnum;
      }
      if (this.item.route == 'zdJq') {
        this.num = jqnum;
      }
      if (this.item.route == 'cpDxq') {
        this.num = cp_dxqnum;
      }
      if (this.item.route == 'cpRq') {
        this.num = cp_rqnum;
      }
      if (this.item.route == 'cpJq') {
        this.num = cp_jqnum;
      }
    }
  },

  setup(props) {
    const { isActive, linkProps, updateIsActive } = useVerticalNavMenuLink(props.item)
    const { t } = useI18nUtils()
    const { canViewVerticalNavMenuLink } = useAclUtils()

    return {
      isActive,
      linkProps,
      updateIsActive,

      // ACL
      canViewVerticalNavMenuLink,

      // i18n
      t,
    }
  },

}
</script>
